var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"data-testid":_vm.getTestId('map-canvas')}})
}
var staticRenderFns = []

export { render, staticRenderFns }